export function getLandingPageVariantString(baseVariant, variant) {
  let formVariant = baseVariant || 'Nue life lead form';
  return variant ? `${formVariant} [variant: ${variant}]` : formVariant;
}